<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <el-alert
      type="warning"
      :closable="false"
      show-icon
      title="寄件运费走汇付延时交易后，支付成功会异步 PaymentConfirm 入平台。常见失败：微信资金冻结（order_freeze）。失败会写入本表并自动重试；也可手动立即重试。不影响用户支付与预约。"
      style="margin-bottom: 12px"
    />

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">支付单号：</span>
          <el-input v-model="query.payOrderNo" clearable placeholder="xwfp/xwpk 模糊" style="width: 200px" @keyup.enter.native="searchFn" />
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">业务：</span>
          <el-select v-model="query.bizType" clearable placeholder="全部" style="width: 130px">
            <el-option label="运费预付" value="PREPAY" />
            <el-option label="寄件运费" value="FREIGHT" />
            <el-option label="退货结算" value="SETTLE" />
          </el-select>
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">状态：</span>
          <el-select v-model="query.status" style="width: 150px">
            <el-option label="未完成" :value="-1" />
            <el-option label="等待首次确认" :value="0" />
            <el-option label="确认失败重试中" :value="1" />
            <el-option label="已确认入账" :value="2" />
            <el-option label="已取消" :value="3" />
          </el-select>
        </div>
        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <div class="table-scroll-wrap">
      <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
        <el-table-column prop="id" label="ID" width="72" align="center" />
        <el-table-column prop="bizTypeLabel" label="业务" width="100" align="center" />
        <el-table-column prop="payOrderNo" label="支付单号" min-width="200" show-overflow-tooltip />
        <el-table-column prop="payPaymentId" label="payment_id" min-width="180" show-overflow-tooltip />
        <el-table-column prop="payAmt" label="金额" width="80" align="right" />
        <el-table-column prop="statusLabel" label="状态" width="120" align="center" />
        <el-table-column prop="huifuConfirmRetryCount" label="重试" width="72" align="center" />
        <el-table-column label="下次尝试" width="168" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.huifuConfirmAfterAt) }}</template>
        </el-table-column>
        <el-table-column prop="lastError" label="失败原因" min-width="220" show-overflow-tooltip />
        <el-table-column label="确认时间" width="168" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.delayConfirmAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.statusCode === 0 || scope.row.statusCode === 1"
              type="text"
              size="small"
              :loading="retryingId === scope.row.id"
              @click="retryNow(scope.row)"
            >立即重试</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  name: "HuifuFreightDelayConfirmList",
  data() {
    return {
      historyArr: ["客诉处理", "运费汇付延时确认"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
      query: {
        payOrderNo: "",
        bizType: "",
        status: -1
      },
      retryingId: null
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    buildPayload() {
      const payload = {
        page: this.currentPage,
        size: this.pageSize,
        status: this.query.status,
        payOrderNo: this.query.payOrderNo || undefined,
        bizType: this.query.bizType || undefined
      };
      return payload;
    },
    fetchList(page) {
      if (page) this.currentPage = page;
      this.loading = true;
      this.$https(this.$api.api.mgmtHuifuFreightDelayConfirmList, this.buildPayload(), "POST")
        .then((res) => {
          const body = (res && res.data) || {};
          if (body.code === 200) {
            this.tableData = body.data || [];
            this.tableTotal = body.size != null ? body.size : 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error(body.msg || "查询失败");
          }
        })
        .catch(() => {
          this.tableData = [];
          this.tableTotal = 0;
          this.$message.error("网络异常");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchFn() {
      this.fetchList(1);
    },
    resetFn() {
      this.query = { payOrderNo: "", bizType: "", status: -1 };
      this.fetchList(1);
    },
    changePage(p) {
      this.fetchList(p);
    },
    handlePageSizeChange() {
      this.fetchList(1);
    },
    retryNow(row) {
      if (!row || !row.id) return;
      this.$confirm("立即向汇付发起运费 PaymentConfirm？若微信资金仍冻结会继续失败并自动排期。", "手动重试", {
        confirmButtonText: "立即重试",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.retryingId = row.id;
          return this.$https(
            this.$api.api.mgmtHuifuFreightDelayConfirmRetry,
            { id: row.id },
            "POST"
          );
        })
        .then((res) => {
          if (!res) return;
          const body = res.data || {};
          if (body.code === 200) {
            this.$message.success(body.msg || "确认成功");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error(body.msg || "重试失败");
            this.fetchList(this.currentPage);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.retryingId = null;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/huifuFreightDelayConfirm/index.vue